import { useEffect, useState } from "react";

const manifestUrl = `${process.env.PUBLIC_URL}/photos/manifest.json`;

const toPublicUrl = (path) => `${process.env.PUBLIC_URL}/${String(path).replace(/^\/+/, "")}`;

export const defaultAspect = 3 / 4;

const aspectCache = new Map();
const pendingLoads = new Map();

export const getCachedAspect = (url) => aspectCache.get(url);

export const loadImageAspect = (url) => {
  if (aspectCache.has(url)) return Promise.resolve(aspectCache.get(url));
  if (pendingLoads.has(url)) return pendingLoads.get(url);
  const pending = new Promise((resolve) => {
    const image = new Image();
    image.decoding = "async";
    const finish = (aspect) => {
      aspectCache.set(url, aspect);
      pendingLoads.delete(url);
      resolve(aspect);
    };
    image.onload = () => {
      const aspect = image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : defaultAspect;
      const decoded = typeof image.decode === "function" ? image.decode().catch(() => undefined) : Promise.resolve();
      decoded.then(() => finish(aspect));
    };
    image.onerror = () => finish(defaultAspect);
    image.src = url;
  });
  pendingLoads.set(url, pending);
  return pending;
};

export const preloadImages = (urls) => Promise.all(urls.map(loadImageAspect));

export default function usePhotoMonths() {
  const [months, setMonths] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(manifestUrl)
      .then((response) => {
        if (!response.ok) throw new Error("manifest unavailable");
        return response.json();
      })
      .then((data) => {
        if (cancelled) return;
        const rawMonths = Array.isArray(data && data.months) ? data.months : [];
        const loadedMonths = rawMonths
          .map((photos, index) => ({
            monthNumber: index + 1,
            photos: (Array.isArray(photos) ? photos : []).map(toPublicUrl),
          }))
          .filter((month) => month.photos.length > 0);
        setMonths(loadedMonths);
      })
      .catch(() => {
        if (!cancelled) setMonths([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return months;
}
